import { useAuthUserStore } from "@/stores/authUser";

export default function parentOnly() {
    const authUserStore = useAuthUserStore();
    const u = authUserStore.user;
    if (u && u.type !== "parent") {
        return {
            name: "login"
        };
    }
}
